import template from './contentTools.tmpl.html'
import Controller from './contentTools.controller'

export default {
  template,
  restrict: 'EA',
  replace: true,
  bindings: {
    index: '<',
    hasProperties: '=',
    openPreview: '=',
    deleteContentElement: '=',
    hasPreview: '=',
    showPropModal: '=',
    feature: '=',
  },
  controllerAs: 'vm',
  controller: Controller,
}
